import {
  TComponentValue,
} from '@/types/openapi-type';

const details: Record<TComponentValue<'AuditEnvelopStabilizationCombinationType'>, string> = {
  0: 'Dodaj czas do ignorowanych etapów.',
  1: 'Albo czas, albo etapy, cokolwiek skończy się pierwsze.',
  2: 'Albo czas, albo etapy, cokolwiek kończy się jako ostatnie.',
};

export default {
  details,
};
